/**
 * Handle Code File
 */
export const handleCodeFile = async (file, code, toast) => {
  let fileText = file.text();

  toast.promise(fileText, {
    loading: "Importing code...",
    success: "Code imported",
    error: "Error while importing code",
  });
  let tempCode = { ...code };
  tempCode = code = await fileText;
  return tempCode;
};

/**
 * Handle File Upload Listeners
 */

export const dragOver = (e) => {
  e.preventDefault();
  e.dataTransfer.dropEffect = "copy";
  e.target.classList.add("bg-indigo-50", "bg-opacity-50", "border-indigo-300");
};

export const dragLeave = (e) => {
  e.preventDefault();
  e.target.classList.remove(
    "bg-indigo-50",
    "bg-opacity-50",
    "border-indigo-300"
  );
};

export const drop = async (e, code, setCode , setShow, toast) => {
  e.preventDefault();
  let file = e.dataTransfer?.files[0];
  let isTxtFile =
    file?.type.split("/")[0] === "text" || file.type.includes("json");
  if (isTxtFile) {
    let tempState = await handleCodeFile(file, code, toast);
    setShow(false);
    setCode(tempState);
  } else {
    setShow(false);
    toast.error("Unsupported file format");
  }
};
